import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';

//Import Components
import Navbar from "./Navbar/Navbar"
import RoadMap from "./RoadMap/road-map"
import FAQs from "./Faqs/FAQs"
import Footer from "./Footer/footer"

const PublicCustomerComplaints = () => {
  const [imglight, setimglight] = useState(true)
  const [navClass, setnavClass] = useState("")

  // Use ComponentDidMount
  useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true)
  },[])

  function scrollNavigation() {
    var scrollup = document.documentElement.scrollTop
    if (scrollup > 80) {
      setimglight(false)
      //setnavClass("nav-sticky")
    } else {
      setimglight(true)
      setnavClass("")
    }
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Customer Complaints | Hargeysa Water Agency </title>
      </MetaTags>
      {/* import navbar */}
      <Navbar navClass={navClass} imglight={imglight} />






      {/* roadmap */}
      <RoadMap />

      {/* faqs */}
    

      {/* footer */}
      <Footer />
    </React.Fragment>
  )
}

export default PublicCustomerComplaints
